import { ADJUST_MORE_FROM_BRAND_FE_LOADING_OFFSET_240828 } from "@faire/web-api/indigofair/settings/ADJUST_MORE_FROM_BRAND_FE_LOADING_OFFSET_240828";

import { useAssignSetting } from "@faire/retailer/settings/__internal__/useSetting";
import { useSetting } from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingAdjustMoreFromBrandLoadingOffset = (): number =>
  useSetting(ADJUST_MORE_FROM_BRAND_FE_LOADING_OFFSET_240828, -100);

export const useAssignSettingAdjustMoreFromBrandLoadingOffset = () =>
  useAssignSetting(ADJUST_MORE_FROM_BRAND_FE_LOADING_OFFSET_240828);
